import React, { useCallback, useState, useEffect } from 'react';
import { useHistory, useParams } from "react-router-dom";

import Utils from "../../utilities/Utils";
import { showToast } from "../ToastManager";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";

import AgendaPrestadorService from '../../service/AgendaService';
import AuthorizationService from '../../service/AuthorizationService';

const agendaPrestadorService = new AgendaPrestadorService(); // Create an instance of AgendaPrestadorService

const ListarAgendaPrestadores = () => {
    const [agendaPrestador, setAgendaPrestadores] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [loading1, setLoading1] = useState(false);
    const history = useHistory();
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [agenda, setAgendaPrestadorParaDeletar] = useState(null);

    const iss = localStorage.getItem('iss');
    const { id } = useParams();

    const initAgendaPrestadores = useCallback(async () => {
        setLoading1(true);

        try {
            const data = await agendaPrestadorService.listAgendaPrestadores(iss);
            setAgendaPrestadores(data.data.rows);
        } catch (error) {
            console.error("Erro ao carregar agendas:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar agendas' });
        } finally {
            setLoading1(false);
        }
    }, [iss])

    const initFilters1 = () => {
        setFilters1({
            'prestadorTipoAgendamento.prestador.nome': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'prestadorTipoAgendamento.tipoAgendamento.companies.name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'prestadorTipoAgendamento.tipoAgendamento.nome': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'dia_semana': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        });
    }

    useEffect(() => {
        initFilters1();
        initAgendaPrestadores();
    }, [initAgendaPrestadores]);

    const irParaCadastro = () => {
        if (AuthorizationService.hasPermission('postAgendaPrestador'))
            history.push('/agenda/cadastrar');
    }

    const abreModalDeletar = (agendaPrestador) => {
        setAgendaPrestadorParaDeletar(agendaPrestador);
        setDeleteDialog(true);
    }

    const handleDeleteAgendaPrestador = () => {
        if (AuthorizationService.hasPermission('deleteAgendaPrestador')) {
            setLoading1(true)
            agendaPrestadorService.deleteAgendaPrestador(iss, agendaPrestador.id).then(() => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: 'AgendaPrestador excluído com sucesso' });
                setLoading1(false);
                hideModalDeletar();
                initAgendaPrestadores();
            });
        }
    }

    const editar = (agendaPrestadorParaEditar) => {
        if (AuthorizationService.hasPermission('getAgendaPrestador'))
            history.push('/agenda/editar/' + agendaPrestadorParaEditar.id);
    }

    const hideModalDeletar = () => {
        setDeleteDialog(false);
        setAgendaPrestadorParaDeletar(null);
    }

    const ativoBody = (rowData) => {
        // const status = rowData.status === "Ativo" ? true : false
        return <span className="p-inputgroup-addon p-inputgroup-addon-checkbox"><Checkbox checked={rowData.ativo} disabled binary /></span>
    }

    const opcoesBody = (rowData) => {
        return <span style={{ display: 'flex', justifyContent: 'space-between' }}>
            {AuthorizationService.hasPermission('deleteAgendaPrestador') ? <Button icon="pi pi-trash" onClick={() => { abreModalDeletar(rowData) }} style={{ backgroundColor: 'red', borderColor: 'red' }} className="p-button-rounded mr-2 mb-2" /> : <></>}
            {AuthorizationService.hasPermission('getAgendaPrestador') ? <Button icon="pi pi-pencil" onClick={() => { editar(rowData) }} className="p-button-rounded  mr-2 mb-2" /> : <></>}
        </span>
    }

    const statusBody = (rowData) => {
        if (rowData.status === 'ATIVO')
            // return <Button icon="pi pi-check" onClick={() => { }} style={{ backgroundColor: 'green', borderColor: 'green' }} className="p-button-rounded mr-2 mb-2" />
            return <span className={`customer-badge status-qualified`}>{rowData.status}</span>;
        if (rowData.status === 'INATIVO')
            // return <Button icon="pi pi-minus" onClick={() => { }} style={{ backgroundColor: 'yellow', borderColor: 'yellow' }} className="p-button-rounded mr-2 mb-2" />
            return <span className={`customer-badge status-negotiation`}>{rowData.status}</span>;
        if (rowData.status === 'BLOQUEADO')
            // return <Button icon="pi pi-times" onClick={() => { }} style={{ backgroundColor: 'red', borderColor: 'red' }} className="p-button-rounded mr-2 mb-2" />
            return <span className={`customer-badge status-unqualified`}>{rowData.status}</span>;
    }

    const deleteAgendaPrestadorDialogFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalDeletar} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeleteAgendaPrestador} />
        </>
    );

    return (
        <div className="grid table-demo">
            <div className="col-12">
                {AuthorizationService.hasPermission('postAgendaPrestador') ? <Button label="Cadastrar" onClick={irParaCadastro} className="mr-2 mb-2"></Button> : <></>}
                <div className="card">
                    <h5>Agenda do Prestador</h5>
                    <DataTable value={agendaPrestador} paginator className="p-datatable-gridlines" showGridlines rows={10}
                        dataKey="id" filters={filters1} onFilter={(event) => setFilters1(event.filters)} filterDisplay="menu" loading={loading1} responsiveLayout="scroll"
                        emptyMessage="Nenhuma agenda cadastrada.">
                        <Column sortable field="prestadorTipoAgendamento.prestador.nome" header="Prestador" filter filterPlaceholder="Procurar por prestador" style={{ minWidth: '12rem' }} />
                        <Column sortable field="prestadorTipoAgendamento.tipoAgendamento.companies.name" header="Empresa" filter filterPlaceholder="Procurar por empresa" style={{ minWidth: '12rem' }} />
                        <Column sortable field="prestadorTipoAgendamento.tipoAgendamento.nome" header="Serviço" filter filterPlaceholder="Procurar por serviço" style={{ minWidth: '10rem' }} />
                        <Column sortable field="dia_semana" header="Dia semana" filter filterPlaceholder="Procurar por dia semana" style={{ minWidth: '11rem' }} />
                        <Column sortable field="hora_inicio" header="Hora início" filter filterPlaceholder="Procurar por cpf" style={{ minWidth: '8rem' }} />
                        <Column sortable field="hora_fim" header="Hora fim" filter filterPlaceholder="Procurar por telefone" style={{ minWidth: '8rem' }} />
                        <Column sortable field="intervalo_atendimento" header="Intervalo" filter filterPlaceholder="Procurar por e-mail" style={{ minWidth: '8rem' }} />
                        <Column sortable body={statusBody} header="Status" filter filterPlaceholder="Procurar por e-mail" style={{ minWidth: '8rem' }} />
                        <Column header="Opções" body={opcoesBody} style={{ width: '8rem' }} />
                    </DataTable>
                </div>
            </div>

            <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Deletar" modal footer={deleteAgendaPrestadorDialogFooter} onHide={hideModalDeletar}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Tem certeza que deseja excluir o agenda do prestador selecionado?</span>
                </div>
            </Dialog>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(ListarAgendaPrestadores, comparisonFn);
